import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async e => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      await login(email, password);
      navigate('/masters');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed');
    } finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg-tertiary)' }}>
      <div style={{ background: 'var(--bg-primary)', border: '0.5px solid var(--border-md)', borderRadius: 16, padding: 36, width: 380 }}>
        <div style={{ marginBottom: 28, textAlign: 'center' }}>
          <div style={{ fontSize: 26, fontWeight: 500, color: 'var(--text-primary)', marginBottom: 4 }}>
            <span style={{ color: 'var(--acc)' }}>Skill</span>flo
          </div>
          <div style={{ fontSize: 12.5, color: 'var(--text-secondary)' }}>Skill Deployment & Line Balancing</div>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 12 }}>
            <div style={{ fontSize: 11, fontWeight: 500, color: 'var(--text-secondary)', marginBottom: 5 }}>Email</div>
            <input
              className="inp" type="email" value={email} placeholder="you@company.com"
              onChange={e => setEmail(e.target.value)} style={{ width: '100%' }} required
            />
          </div>
          <div style={{ marginBottom: 20 }}>
            <div style={{ fontSize: 11, fontWeight: 500, color: 'var(--text-secondary)', marginBottom: 5 }}>Password</div>
            <input
              className="inp" type="password" value={password} placeholder="••••••••"
              onChange={e => setPassword(e.target.value)} style={{ width: '100%' }} required
            />
          </div>
          {error && <div style={{ fontSize: 11.5, color: 'var(--red)', background: 'var(--red-bg)', padding: '7px 10px', borderRadius: 7, marginBottom: 12 }}>{error}</div>}
          <button
            type="submit" className="btn btn-p" style={{ width: '100%', justifyContent: 'center', padding: '8px 0' }}
            disabled={loading}
          >
            {loading ? 'Signing in…' : 'Sign in'}
          </button>
        </form>

        <div style={{ marginTop: 16, textAlign: 'center', fontSize: 11.5, color: 'var(--text-secondary)' }}>
          Forgot your password? Contact the Super Admin.
        </div>
      </div>
    </div>
  );
}